module.exports = __webpack_public_path__ + "img/secure.fc7d7e6c.png";